export default __webpack_public_path__ + "static/media/netflix.7291e167.png";